import "esbuild-css-modules-plugin-ns-css:src/chat-ui/components/ChatPanel/TextChatUIComponent.module.css";

import { inject } from "esbuild-css-modules-plugin-ns-js:src/chat-ui/components/ChatPanel/TextChatUIComponent.module.css:injector.js";
export default new Proxy({
  "closeButton": "TextChatUIComponent-module__closeButton_gFDdcW__0190",
  "controls": "TextChatUIComponent-module__controls_gFDdcW__0190",
  "fadeIn": "TextChatUIComponent-module__fadeIn_gFDdcW__0190",
  "fadeOut": "TextChatUIComponent-module__fadeOut_gFDdcW__0190",
  "messagesWrapper": "TextChatUIComponent-module__messagesWrapper_gFDdcW__0190",
  "openTab": "TextChatUIComponent-module__openTab_gFDdcW__0190",
  "stickyButton": "TextChatUIComponent-module__stickyButton_gFDdcW__0190",
  "stickyButtonEnabled": "TextChatUIComponent-module__stickyButtonEnabled_gFDdcW__0190",
  "stickyButtonFadeOut": "TextChatUIComponent-module__stickyButtonFadeOut_gFDdcW__0190",
  "textChat": "TextChatUIComponent-module__textChat_gFDdcW__0190",
  "textChatUi": "TextChatUIComponent-module__textChatUi_gFDdcW__0190",
  "uiHover": "TextChatUIComponent-module__uiHover_gFDdcW__0190"
}, {
  get: function(source, key) {
    inject();
    return source[key];
  }
});
      